import "./main-layout.scss";
import { FooterScreenFactory } from "@layout/footer";
import { HeaderScreenFactory } from "@layout/header";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
  return (
    <>
      <HeaderScreenFactory />
      <div className="main-content">
        <Outlet />
      </div>
      <FooterScreenFactory />
    </>
  );
}